<template>
  <component 
    :is="content.content.includes('vimeo') ? 'VimeoComponent' : 'VideohubComponent'"
    :key="content.id"
  />
</template>
<script>
import { mapGetters } from "vuex";
import VimeoComponent from './VimeoComponent/Index.vue';
import VideohubComponent from './VideohubComponent/Index.vue';

export default {
  components: { VimeoComponent, VideohubComponent },
  computed:{
    ...mapGetters(['module','contents','activeTab','content']),
  },
}
</script>
<style lang="css" scoped>
.bg-inDarkActive:active {
  background-color: rgba(6, 1, 129, 0.3) !important;
}
</style>